import React from 'react';

const IconCheck = () => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6666 1.50098L4.24998 7.91764L1.33331 5.00098"
      stroke="#59d5d3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCheck;
